<div class="container">
  <article>
    <h1>Hello, I'm Shafi Rayhan!</h1>
    <p>I'm a Front-End Web Developer based in Sylhet.</p>
    <p>
      I have been creating websites since 2019 and have mastered HTML, CSS,
      JavaScript, React & GatsbyJS.
    </p>
    <p>
      Nowadays I'm spending my time trying to learn NodeJS, GraphQL, SCSS
      Angular, TypeScript and many more web technologies.
    </p>
    <p>Contact me if you want me to create a website for you.</p>
  </article>
  <a
    href="mailto:rayhanshafi7@gmail.com?subject=Give%20Me%20Quotes%20for%20Creating%20a%20Website"
    mat-raised-button
    class="button"
  >
    CONTACT ME
  </a>
</div>
